import type { ConceptDef } from '../types';

export const matchCase: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-case',
  label: 'Match Upper-to-Lower Case',
  category: 'Matching',
  description: 'See an uppercase letter; tap the matching lowercase letter.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: 'A', answer: 'a' },
      { say: 'B', answer: 'b' },
      { say: 'C', answer: 'c' },
      { say: 'D', answer: 'd' },
      { say: 'E', answer: 'e' },
      { say: 'F', answer: 'f' },
    ],
  },
};
